const dataFaq = [
    {
        id: 1,
        title: 'What are the NFTs?',
        content: 'The first generation NFT is made for stacking , anyone who bought the NFTs can get revenues from stacking',
        show: 'show'
    },
    {
        id: 2,
        title: 'How do I get NFTs?',
        content: 'You can get the NFT in our minting page, the NFT price is 200 BUSD for each',
    },
    {
        id: 3,
        title: 'What are the utilities of the NFT?',
        content: 'The first utility : Staking, you can stack the NFT to get revenue from stacking.',
    },
    {
        id: 4,
        title: 'What are the utilities of the NFT?',
        content: 'The second utility : FREE Token Smart Contract Deploy, anyone who "mint" the NFT can have ONE chance of free writing a smart contract',
    },
    {
        id: 5,
        title: 'More Details of the NFT utilities',
        content: 'For More Details of the utilities, please check them our on the NFT Utility Page',
    },
    {
        id: 6,
        title: 'For More Details of the second utility',
        content: 'For More Details of the second utility, please contact @RyoLin on the Telegram',
    },
]

export default dataFaq;